import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { WhyItFailed } from './components/WhyItFailed';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { TargetAudience } from './components/TargetAudience';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Offer } from './components/Offer';
import { initMetaPixel, trackPageView } from './lib/pixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-cream selection:bg-terracotta/30" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Problem data-id="element-3" />
        <WhyItFailed data-id="element-4" />
        <Mechanism data-id="element-5" />
        <WhatYouGet data-id="element-6" />
        <TargetAudience data-id="element-7" />
        <HowItWorks data-id="element-8" />
        <Proof data-id="element-9" />
        <FAQ data-id="element-10" />
        <Offer data-id="element-11" />
      </main>
      <footer className="py-8 text-center text-charcoal/50 text-sm bg-charcoal text-cream/50" data-id="element-12">
        <p data-id="element-13">
          © {new Date().getFullYear()} Método ADORMECER. Todos los derechos
          reservados.
        </p>
      </footer>
    </div>;
}